import * as React from 'react';
import * as styles from './style.css';

export interface ILinkProps extends React.HTMLProps<HTMLAnchorElement> {
  children: React.ReactNode;
  onClick?(event: React.SyntheticEvent): void;
  url: string;
  target?: '_self' | '_blank';
}

export function Link(props: ILinkProps) {
  const { children, id, onClick, url, target = '_self' } = props;

  return (
    <a
      target={target}
      id={id}
      rel="noreferrer"
      onClick={(event: React.SyntheticEvent) => {
        if (onClick) {
          onClick(event);
        }
      }}
      href={url}
      className={styles['link']}
    >
      {children}
    </a>
  );
}
